import { useMemo } from "react";
import {
  useGetApiQuery,
  useGetHtmlApiQuery,
} from "../../../redux/services/apiHome";
import { Link, useLocation } from "react-router-dom";
import SwachhBharatTable from "./SwachhBharatTable";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";

const SwachhBharatAbhiyan = () => {
  // const navigate = useNavigate();
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: introductionData = {},
    error: introductionError,
    isLoading: introductionIsLoading,
  } = useGetHtmlApiQuery({ url: 315, lang: languageType });

  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });

  const lastUpdateDateIntroduction = lastUpdatedOnData.filter(
    (item) => item.nid === `315`,
  );

  const {
    data: galleryResponse = {},
    error: galleryError,
    isLoading: galleryIsLoading,
  } = useGetApiQuery({
    url: "swachh-bharat-abhiyan",
    lang: languageType,
  });

  const { data: tableData = [], isLoading: tableIsLoading } =
    useGetProtectedApiDataQuery({
      url: "fulfilling_the_swacchta_sapath",
      lang: languageType,
    });

  // const galleryData = galleryResponse.data || [];
  const galleryData = useMemo(
    () => galleryResponse.data || [],
    [galleryResponse.data],
  );

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData([
      ...galleryData,
      ...tableData,
      ...lastUpdateDateIntroduction,
    ]);
  }, [galleryData, tableData, lastUpdateDateIntroduction]);

  const introDesc = introductionData?.body?.[0]?.value || "Data not available";

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (
    introductionIsLoading ||
    galleryIsLoading ||
    tableIsLoading ||
    lastUpdatedIsLoading
  ) {
    return <Loader />;
  }

  if (introductionError) {
    return <p>Error loading introduction: {introductionError.message}</p>;
  }

  if (galleryError) {
    return <p>Error loading gallery data: {galleryError.message}</p>;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Sustainable Development", "सतत विकास")}
        titleLink="/sustainable-development/swachh-bharat-abhiyan"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="title-sec">
            {/* <h4>{title}</h4> */}
            <div className="about_inntxt mb-5">
              <div dangerouslySetInnerHTML={{ __html: introDesc }}></div>
            </div>
          </div>
          {/* table */}
          <SwachhBharatTable tableData={tableData} />

          <div className="title-sec">
            <h2>{getText("Photo Gallery", "फ़ोटो गैलरी")}</h2>
          </div>

          {/* gallery */}

          <div className="row wow zoomIn">
            {galleryData?.length > 0 ? (
              galleryData.map((item, index) => (
                <div className="col-12 col-sm-12 col-md-3 col-lg-3" key={index}>
                  <div className="gallery-card">
                    <div className="crd-title">
                      <p className="title-txt">{item.title}</p>
                    </div>
                    <div className="card-imgs">
                      {item.field_events_image
                        .slice(0, 2)
                        .map((photo, photoIndex) => (
                          <img
                            key={photoIndex}
                            src={`${process.env.REACT_APP_IMAGE_URL}${photo?.image_url}`}
                            alt={
                              photo?.image_descriptions ||
                              `${
                                item.title ||
                                getText("Photo gallery", "फ़ोटो गैलरी")
                              } ${getText("photo", "फोटो")} ${photoIndex + 1}`
                            }
                          />
                        ))}
                    </div>
                    <div className="card-buttons">
                      <Link
                        // href=""
                        to={`/sustainable-development/swachh-bharat-abhiyan/${item.id}`}
                        className="quick-btn"
                      >
                        {getText("View More", "और देखो")}
                      </Link>
                    </div>
                  </div>
                </div>
                // <div
                //   className="col-12 col-sm-12 col-md-3 col-lg-3 mb-4 print-gallery3"
                //   key={index}
                // >
                //   <div
                //     className="card-sec wow zoomIn"
                //     style={{ visibility: "visible", animationName: "zoomIn" }}
                //   >
                //     <div className="img-sec">
                //       <img
                //         alt={item?.field_events_image?.[0]?.image_descriptions}
                //         src={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_events_image?.[0]?.image_url}`}
                //       />
                //     </div>
                //     <div className="desc-sec">
                //       <div className="title-sec">
                //         <h2>
                //           <a
                //             href="#"
                //             onClick={(e) => {
                //               e.preventDefault();
                //               navigate(
                //                 `/sustainable-development/swachh-bharat-abhiyan/${item.id}`
                //               );
                //             }}
                //           >
                //             {item.title}
                //           </a>
                //         </h2>
                //       </div>
                //     </div>
                //   </div>
                // </div>
              ))
            ) : (
              <div className="col-12">
                <p>
                  {getText(
                    "No gallery items found",
                    "कोई गैलरी आइटम नहीं मिला",
                  )}
                </p>
              </div>
            )}
          </div>

          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
        </div>
      </div>
    </>
  );
};

export default SwachhBharatAbhiyan;
